/** Health of one data feed on the Command Center home Data coverage widget. */
export enum ECoverageState {
  OK = "ok",
  /** Last sync errored, or the health check itself failed */
  FAILED = "failed",
  /** Syncing but behind, partial, or data stopped arriving */
  STALE = "stale",
  /** Expected for this product but never integrated */
  MISSING = "missing",
}

export enum ECoverageKind {
  REVENUE = "revenue",
  AD_SPEND = "ad_spend",
  ATTRIBUTION = "attribution",
  FORECAST = "forecast",
  ENGINEERING = "engineering",
  DOCS = "docs",
}
